// REISOR_STAGE22A_DRIVER_TRIAL_ACCESS_SUBSCRIPTION_V1
// "Referral" file name is legacy; product UI is now plain share-app, no codes, no bonuses.

const COPY = {
  uz: {
    modalTitle: "Иловани улашиш",
    cardTitle: "Иловани улашиш",
    cardText:
      "REISOR ҳаволасини бошқа ҳайдовчи билан улашинг. Янги тасдиқланган ҳайдовчи REISOR функцияларига бепул синов доступини олади.",
    shareButton: "Иловани улашиш",
    copyButton: "Ҳаволани нусхалаш",
    copiedButton: "Нусхаланди",
    inviteLink: "Илова ҳаволаси",
    trialAvailable:
      "Профилингиз тасдиқланганидан кейин REISOR бепул синов доступини беради. REISOR PRO ва REISOR HUB учун синов муддати алоҳида белгиланади.",
    trialUsed:
      "Синов доступи тугади. Ёпиқ функциялар учун тегишли REISOR обунасини фаоллаштиринг.",
    trialExpired:
      "Бепул давр тугади. Савдоларда қатнашиш учун REISOR доступини фаоллаштиринг.",
    subscriptionUz: "REISOR доступи: 30 000 сўм / 30 кун. Буюртмалардан комиссия йўқ.",
    subscriptionRu: "REISOR доступи: 199 ₽ / 30 кун. Буюртмалардан комиссия йўқ.",
    shareTitle: "REISOR",
    shareText: ({ link }) =>
      [
        "REISOR — юк ташиш буюртмалари ва савдолар учун платформа.",
        "Янги тасдиқланган ҳайдовчи REISORдан бепул синов доступини олади.",
        link || "",
      ].filter(Boolean).join("\n"),
  },
  tr: {
    modalTitle: "Uygulamayı paylaş",
    cardTitle: "Uygulamayı paylaş",
    cardText:
      "REISOR bağlantısını başka bir sürücüyle paylaşın. Yeni onaylanan sürücü ücretsiz REISOR deneme erişimi alır.",
    shareButton: "Uygulamayı paylaş",
    copyButton: "Bağlantıyı kopyala",
    copiedButton: "Kopyalandı",
    inviteLink: "Uygulama bağlantısı",
    trialAvailable:
      "Profil onayından sonra ücretsiz REISOR deneme erişimi başlar. REISOR PRO ve REISOR HUB için deneme süreleri ayrı belirlenir.",
    trialUsed:
      "Deneme erişimi sona erdi. Kullanılamayan özellikler için ilgili REISOR aboneliğini etkinleştirin.",
    trialExpired:
      "Ücretsiz dönem sona erdi. Tekliflere katılmak için REISOR erişimini etkinleştirin.",
    subscriptionUz: "REISOR erişimi: 30.000 som / 30 gün. Sipariş komisyonu yok.",
    subscriptionRu: "REISOR erişimi: 199 ₽ / 30 gün. Sipariş komisyonu yok.",
    shareTitle: "REISOR",
    shareText: ({ link }) =>
      [
        "REISOR — yük siparişleri ve teklif verme platformudur.",
        "Yeni onaylanan sürücü ücretsiz REISOR deneme erişimi alır.",
        link || "",
      ].filter(Boolean).join("\n"),
  },
  ru: {
    modalTitle: "Поделиться приложением",
    cardTitle: "Поделиться приложением",
    cardText:
      "Поделитесь ссылкой на REISOR с другим водителем. Новый одобренный водитель получает бесплатный пробный доступ к функциям REISOR.",
    shareButton: "Поделиться приложением",
    copyButton: "Скопировать ссылку",
    copiedButton: "Скопировано",
    inviteLink: "Ссылка на приложение",
    trialAvailable:
      "После одобрения профиля предоставляется бесплатный пробный доступ REISOR. Срок доступа к REISOR PRO и REISOR HUB устанавливается отдельно.",
    trialUsed:
      "Пробный доступ REISOR завершён. Для недоступных функций активируйте соответствующую подписку REISOR.",
    trialExpired:
      "Бесплатный период завершён. Для участия в торгах активируйте доступ REISOR.",
    subscriptionUz: "Доступ REISOR: 30 000 сум / 30 дней. Комиссии с заказов нет.",
    subscriptionRu: "Доступ REISOR: 199 ₽ / 30 дней. Комиссии с заказов нет.",
    shareTitle: "REISOR",
    shareText: ({ link }) =>
      [
        "REISOR — платформа для заявок на перевозку и торгов.",
        "Новый одобренный водитель получает бесплатный пробный доступ REISOR.",
        link || "",
      ].filter(Boolean).join("\n"),
  },
};

export function getDriverReferralPromoCopy(lang) {
  const key = String(lang || "ru").split("-")[0].toLowerCase();
  return COPY[key] || COPY.ru;
}
